import * as types from "./mutation_types"

export default {
    [types.RESET](state){
        Object.assign(state,{
            isLoading: false,
            update: {},
            isUpdated:false,
            showMessage: false,
            message: "",
            isSuccess: false,
            currentItem: null,
            modal: {
                title: "__",
                description: "__",
                type: "default",
                content: '',
    
    
            },
            showModal: false,
    
        })
    },
    [types.SET_TOGGLE_LOADING](state){
        Object.assign(state,{isLoading:!state.isLoading})
    },
    [types.SET_SHOW_LOADING](state){
        Object.assign(state,{isLoading:true})
    },
    [types.SET_HIDE_LOADING](state){
        Object.assign(state,{isLoading:false})
    },
    [types.SET_TOGGLE_MESSAGE](state){
        Object.assign(state,{showMessage:!state.showMessage})
    },
    [types.SET_SHOW_MESSAGE](state){
        Object.assign(state,{showMessage:true})
    },
    [types.SET_HIDE_MESSAGE](state){
        Object.assign(state,{showMessage:false})
    },
    [types.SET_TOGGLE_MODAL](state){
        Object.assign(state,{showModal:!state.showModal})
    },
    [types.SET_SHOW_MODAL](state){
        Object.assign(state,{showModal:true})
    },
    [types.SET_HIDE_MODAL](state){
        Object.assign(state,{showModal:false})
    },
    [types.SET_MODAL](state,modal){
        Object.assign(state,{modal})
    },
    [types.SET_MODAL_TITLE](state,title){
        Object.assign(state,{modal:{...state.modal,title}})
    },
    [types.SET_MODAL_SUBTITLE](state,subtitle){
        Object.assign(state,{modal:{...state.modal,subtitle}})
    },
    [types.SET_MODAL_TYPE](state,type){
        Object.assign(state,{modal:{...state.modal,type}})
    },
    [types.SET_MODAL_CONTENT](state,content){
        Object.assign(state,{modal:{...state.modal,content}})
    },
    [types.SET_IS_SUCCESS](state){
        Object.assign(state,{isSuccess:true})
    },
    [types.SET_IS_ERROR](state){
        Object.assign(state,{isSuccess:false})
    },
    [types.SET_MESSAGE](state,message){
        Object.assign(state,{message})
    },
    [types.SET_UPDATE](state,update){
        Object.assign(state,{update})
    },
    [types.SET_IS_UPDATED](state){
        Object.assign(state,{isUpdated:true})
    },
    [types.SET_NOT_UPDATED](state){
        Object.assign(state,{isUpdated:false})
    },
    
    [types.SET_CURRENT_ITEM](state,currentItem){
        Object.assign(state,{currentItem})
    },
}